module.exports = __webpack_public_path__ + "img/coffee-pot.48ab58d8.svg";